import React from 'react';
import { JcCommonProps } from '../../utils/JcUtils';
import { JcColumn } from '../JcBox';

export interface JcAppProps extends JcCommonProps {
    children: React.ReactNode;
}

/**
 * JcApp is a top-level container component that provides the base structure for applications.
 * It applies the "jc-app" class name for consistent styling across applications.
 * 
 * @param props - The component props
 * @returns A React element
 */
export const JcApp = (props: JcAppProps): React.ReactElement => {
    const { children, className, ...rest } = props;

    return (
        <JcColumn {...rest} className={`jc-app ${className || ''}`} flexGrow>
            {children}
        </JcColumn>
    );
};
